import { render, staticRenderFns } from "./TestPayDialog.vue?vue&type=template&id=7932d008&scoped=true&"
import script from "./TestPayDialog.vue?vue&type=script&lang=js&"
export * from "./TestPayDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7932d008",
  null
  
)

export default component.exports